import { render, staticRenderFns } from "./salary_dimension_selector.vue?vue&type=template&id=380f0108"
import script from "./salary_dimension_selector.vue?vue&type=script&lang=js"
export * from "./salary_dimension_selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports